import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-itemwise-profit',
  templateUrl: './itemwise-profit.component.html',
  styleUrls: ['./itemwise-profit.component.scss']
})
export class ItemwiseProfitComponent implements OnInit {

  constructor(public appservice:AppService) {

  
    
  }
  export_excel()
  {
 
   this.appservice.Excel_Data.Header=this.appservice. Itemwise_Profit_Export;
   this.appservice.Excel_Data.items=this.appservice.Item_wise_profit_Row
   this.appservice.Excel_Data.Report_Name="Itemwise Sales"
   this.appservice.export_excel();
 
  }


  Print_Data()
  {
    this.appservice.getc("Api/Hotel/Print_DayitemSales").subscribe((res: any) => {
    
    });
  }


  export_pdf(data)
 {

  this.appservice.Excel_Data.Header=this.appservice. Itemwise_Profit_Export;
  this.appservice.Excel_Data.Total_Row= "Total Rows : "+this.appservice.length_of(data);
 this.appservice.Excel_Data.Total_Amount="Total Amount : "+this.appservice.sum_of(data,'Amount');
  this.appservice.Excel_Data.items=this.appservice.Item_wise_profit_Row
  this.appservice.Excel_Data.Report_Name="Itemwise Sales"
  this.appservice.export_pdf();
  }

 ngOnInit(): void {

 }

}
